export const SCENARIO__CREATE = 'SCENARIO__CREATE'
export const SCENARIO__EDIT_IMPLEMENTED_PLAN = 'SCENARIO__EDIT_IMPLEMENTED_PLAN'
export const SCENARIO__IMPLEMENT = 'SCENARIO__IMPLEMENT'
export const SCENARIO__REQUEST_REVIEW = 'SCENARIO__REQUEST_REVIEW'
export const SCENARIO__ARCHIVE = 'SCENARIO__ARCHIVE'
export const SCENARIO__DOWNLOAD_PDF = 'SCENARIO__DOWNLOAD_PDF'
export const SCENARIO__SEND_PDF = 'SCENARIO__SEND_PDF'
export const SCENARIO__EXPORT_PROJECTIONS = 'SCENARIO__EXPORT_PROJECTIONS'

export const ASSUMPTION__VIEW = 'ASSUMPTION__VIEW'
export const ASSUMPTION__EDIT = 'ASSUMPTION__EDIT'

export const JOINT_PLAN__CREATE = 'JOINT_PLAN__CREATE'
export const JOINT_PLAN__VIEW = 'JOINT_PLAN__VIEW'
export const JOINT_PLAN__DELETE = 'JOINT_PLAN__DELETE'
export const JOINT_PLAN__EDIT = 'JOINT_PLAN__EDIT'
export const JOINT_PLAN__DOWNLOAD_PDF = 'JOINT_PLAN__DOWNLOAD_PDF'

export const CUSTOMER_SUPPORT_TICKET__QUICK_REPORT_ISSUE = 'CUSTOMER_SUPPORT_TICKET__QUICK_REPORT_ISSUE'

export const INVESTMENT_PROPOSAL__CREATE = 'INVESTMENT_PROPOSAL__CREATE'

// "Coarse" feature names translated from feature toggles yet to be migrated
// to permissions. These were boolean toggles and thus cover the entire feature.
export const WEALTH_MANAGER_REQUEST__ALL = 'WEALTH_MANAGER_REQUEST__ALL'
export const ASTUTE_CCP__ALL = 'ASTUTE_CCP__ALL'
export const FNA__ALL = 'FNA__ALL'
export const SCENARIO_IMPLEMENTED_PLAN_READ_ONLY__ALL = 'SCENARIO_IMPLEMENTED_PLAN_READ_ONLY__ALL'
export const MOMENTUM_POC__ALL = 'MOMENTUM_POC__ALL'
export const CLIENT_PDF_REPORT__ALL = 'CLIENT_PDF_REPORT__ALL'
export const CLIENT_LIABILITY__ALL = 'CLIENT_LIABILITY__ALL'
export const ASSET_EVENT__ALL = 'ASSET_EVENT__ALL'

export const ASSET__AUTO_LINKING = 'ASSET__AUTO_LINKING'

export const NOTE__EDIT = 'NOTE__EDIT'
export const NOTE__CREATE = 'NOTE__CREATE'
export const NOTE__VIEW_PRIVATE = 'NOTE__VIEW_PRIVATE'

// A convenience export including all feature names
const FeatureNames = {
  SCENARIO__CREATE,
  SCENARIO__EDIT_IMPLEMENTED_PLAN,
  SCENARIO__IMPLEMENT,
  SCENARIO__REQUEST_REVIEW,
  SCENARIO__ARCHIVE,
  SCENARIO__DOWNLOAD_PDF,
  SCENARIO__SEND_PDF,
  SCENARIO__EXPORT_PROJECTIONS,

  ASSUMPTION__VIEW,
  ASSUMPTION__EDIT,

  JOINT_PLAN__CREATE,
  JOINT_PLAN__VIEW,
  JOINT_PLAN__DELETE,
  JOINT_PLAN__EDIT,
  JOINT_PLAN__DOWNLOAD_PDF,

  CUSTOMER_SUPPORT_TICKET__QUICK_REPORT_ISSUE,

  WEALTH_MANAGER_REQUEST__ALL,
  ASTUTE_CCP__ALL,
  FNA__ALL,
  SCENARIO_IMPLEMENTED_PLAN_READ_ONLY__ALL,
  MOMENTUM_POC__ALL,
  CLIENT_PDF_REPORT__ALL,
  CLIENT_LIABILITY__ALL,

  ASSET__AUTO_LINKING,
  ASSET_EVENT__ALL,

  NOTE__EDIT,
  NOTE__CREATE,
  NOTE__VIEW_PRIVATE,

  INVESTMENT_PROPOSAL__CREATE
}

export default FeatureNames
